import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowRight } from "lucide-react";
const BG = "https://images.unsplash.com/photo-1680992046626-418f7e910589?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxzZXJ2ZXIlMjByb29tJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3ODcyMzg1NjN8MA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u?.role === "customer" ? "/portal" : "/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:block lg:w-1/2 relative">
        <img src={BG} alt="server room" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#1B2A4A]/85" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12">
          <div className="flex items-center gap-2">
            <div className="bg-white rounded-sm px-3 py-2 inline-flex">
              <img src="/grcom-logo.png" alt="CV GRcom" className="h-7 w-auto" />
            </div>
          </div>
          <div>
            <div className="overline text-accent mb-4">IT Support & Infrastruktur</div>
            <h1 className="font-heading font-black text-4xl xl:text-5xl text-white tracking-tight leading-tight">
              AI Admin untuk<br />Negosiasi & Penawaran
            </h1>
            <p className="text-white/70 mt-4 max-w-md text-sm">
              Otomasi harga, penawaran, negosiasi, hingga penerbitan invoice untuk klien korporat Anda.
            </p>
          </div>
          <div className="overline text-white/50">© 2026 GRCom · 13+ Tahun Pengalaman</div>
        </div>
      </div>

      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-background grid-noise">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <div className="bg-white rounded-sm px-3 py-2 inline-flex">
              <img src="/grcom-logo.png" alt="CV GRcom" className="h-7 w-auto" />
            </div>
          </div>
          <div className="overline text-muted-foreground mb-2">Masuk</div>
          <h2 className="font-heading font-bold text-2xl tracking-tight mb-8">Selamat datang kembali</h2>

          <div className="space-y-4">
            <div>
              <Label className="overline text-muted-foreground">Email</Label>
              <Input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 rounded-sm bg-secondary border-border"
                required
              />
            </div>
            <div>
              <Label className="overline text-muted-foreground">Password</Label>
              <Input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 rounded-sm bg-secondary border-border"
                required
              />
            </div>
          </div>

          {error && (
            <div data-testid="login-error" className="mt-4 text-sm text-destructive font-mono">
              {error}
            </div>
          )}

          <Button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full mt-6 rounded-sm group"
          >
            {loading ? "Memproses…" : "Masuk"}
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-0.5 transition-transform" />
          </Button>
          <Link to="/forgot-password" className="block text-center text-xs text-muted-foreground hover:text-foreground mt-4" data-testid="login-forgot-link">Lupa password?</Link>
        </form>
      </div>
    </div>
  );
}
